import React from 'react';

function FourOhFour() {
  return (
    <div>You're lost</div>
  )
}

export default FourOhFour;
